<template>
    <div>
        <AGISHeader title="Airfield Ground Lighting System" :subMenuItems="subMenuItems" :helpVisible="false"/>
        <AGISRouteView :subMenuItems="subMenuItems" ref="agis-route-view"/>
    </div>
</template>

<script>
import AGISHeader from '@/components/ui-components/AGISHeader';
import AGISRouteView from '@/components/ui-components/AGISRouteView';

export default {
  name: 'agls-layout',
  components: {
      AGISHeader,
      AGISRouteView,
  },
  created: function () {
  },
  data:function(){
      return {
        showSidePanel: true,
        subMenuItems: [
            {
                routeName: 'Home',
                title: ' Home'
            },
            {
                routeName: 'Airfield Ground Light Welcome',
                title: ' Welcome'
            },
            {
                routeName: 'AGLAsset',
                title: ' Asset'
            },
            {
                routeName: 'AGLReplacement',
                title: ' Replacement'
            },
            {
                routeName: 'AGLBoltInsp',
                title: ' Bolt Inspection'
            },
            {
                routeName: 'AGLEpoxyInsp',
                title: ' Epoxy Inspection'
            },
            {
                routeName: 'AGLPhotometric',
                title: ' Photometric'
            },
            {
                routeName: 'AGLAAMSAsset',
                title: ' AAMS Asset'
            },
          ]
      }
  },
  methods: {
  }
}

</script>

<style>

.esri-ui-corner .esri-legend{
    font-size:0.7em;
    min-width:10em;
    padding:0;
}
.esri-legend__service{
    padding:0;
}
.esri-legend__service-label{
    margin:0;
}
.esri-legend__layer-table{
    margin-bottom:0;
    text-align: left;
}

.esri-legend__layer-cell{
    padding:0;
    min-width:auto;
}
</style>



// WEBPACK FOOTER //
// src/components/airfield-ground-light-area/Layout.vue